import React from 'react';

import { useIdentity } from '@vp/ubik-context';
import { useLocalizations } from '@vp/ubik-localizations-provider';

import { configuration } from '../infrastructure/serversideConfigurationProvider';
import { designSpecsTabTypename } from '../types/ppV2ContentfulTypes';

import { PdpFlyoutTrigger } from './PdpFlyoutTrigger';
import { SpecsAndTemplates, SpecsAndTemplatesData } from './specs-and-templates';

export type SpecsAndTemplatesWrapperProps = {
  productKey: string;
  productVersion: number;
  locale: string;
  data: SpecsAndTemplatesData;
  mpvId: string;
};
export const SpecsAndTemplatesWrapper: React.FC<SpecsAndTemplatesWrapperProps> = (props) => {
  const { auth } = useIdentity();
  const { t } = useLocalizations();

  return (
    <SpecsAndTemplates
      {...props}
      isAuthInitialized={!!auth}
      authHeader={auth?.getAuthorizationHeader?.()}
      requestor={configuration.requestor}
      trigger={
        <PdpFlyoutTrigger
          iconType="templates"
          label={t('specs-and-templates')}
          flyoutType={designSpecsTabTypename}
          productKey={props.productKey}
        />
      }
    />
  );
};
